<template>
  <div class="Agencys">
    <Agency />
  </div>
</template>

<script>
import Agency from '../components/Agenecy.vue'

export default {
  name: 'Agencys',
  components: {
    Agency
  }
}
</script>